<!--
 * @Description: 深度取证列表
 * @Date: 2019-10-21 09:56:59
 * @LastEditTime: 2021-07-16 09:44:58
 -->
<template>
  <div id="deepForensicList">
    <!-- S 表格筛选 -->
    <TableSearch
      ref="TableSearch"
      v-model="searchForm"
      :options="searchOptions"
      :show-toggle="true"
      @submit="setSearch"
    >
      <div slot="button" class="btn-group">
        <div class="btn-item">
          <el-button :loading="submitLoading" icon="el-icon-delete" @click="handleDeleteSubmit">
            批量删除
          </el-button>
          <!-- <el-button :loading="submitLoading" icon="el-icon-collection" @click="importTips = true">
            导入文件
          </el-button> -->
        </div>
      </div>
      <!-- /表格操作 -->
    </TableSearch>
    <!-- E 表格筛选 -->

    <!-- S 表格 -->
    <div class="forensic-table-wrap">
      <el-table
        v-loading="items.loading"
        class="list-table"
        :data="items.data"
        row-key="id"
        :auto-upload="false"
        tooltip-effect="dark"
        lazy
        :load="handleLoadRecord"
        :tree-props="{children: 'children', hasChildren: 'hasRecords'}"
        @selection-change="val=> multipleSelection = val"
      >
        <el-table-column
          type="selection"
          width="60"
          :selectable="handleSelectable"
          align="center"
        />
        <el-table-column label="泄密样本" width="150" align="center">
          <template slot-scope="scope">
            <el-popover v-if="scope.row.renderType === 1 || scope.row.isTaskRecord == 1" placement="right" trigger="hover" width="284" popper-class="img-names-popover">
              <div class="img-names">
                <div class="name">
                  <p v-if="scope.row.hasRecords ? false : (['pdf', 'ofd'].includes(scope.row.imageName.split('.')[1]))">
                    文档名称：
                  </p>
                  <p v-else-if="scope.row.hasRecords ? false : (videoTypes.includes(scope.row.imageName.split('.')[1]))">
                    视频名称：
                  </p>
                  <p v-else>
                    图片名称：
                  </p>
                  <p>{{ scope.row.imageName }}</p>
                </div>
                <div class="name">
                  <p>源文件名：</p>
                  <p>{{ scope.row.fileOriginalName || "— —" }}</p>
                </div>
              </div>
              <img
                v-if="scope.row.hasRecords ? false : (['pdf', 'ofd'].includes(scope.row.imageName.split('.')[1]))"
                slot="reference"
                src="../../assets/imgs/file.png"
                style="cursor: pointer;"
                alt=""
                width="35"
                height="28"
              >
              <img
                v-else-if="
                  scope.row.hasRecords ? false : (videoTypes.includes(scope.row.imageName.split('.')[1]))
                "
                slot="reference"
                src="../../assets/imgs/u994.svg"
                style="cursor: pointer;"
                alt=""
                width="35"
                height="28"
              >
              <img
                v-else
                slot="reference"
                v-lazy="scope.row.thumbnailPath"
                style="cursor: pointer;"
                width="35"
                height="28"
                @click="handlePreviewImg(scope.row)"
              >
            </el-popover>
            <img
              v-else
              v-lazy="scope.row.thumbnailPath"
              style="cursor: pointer;"
              width="35"
              height="28"
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="上传时间"
          align="center"
          show-overflow-tooltip
        />

        <el-table-column
          prop="userName"
          label="取证用户"
          align="center"
          show-overflow-tooltip
        />

        <el-table-column
          prop="productName"
          label="水印类型"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.taskOrigin == 2" />
            <span v-else>{{ scope.row.productName || '— —' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="所属应用" prop="appName" align="center" min-width="115px">
          <template slot-scope="scope">
            <span v-if="scope.row.taskOrigin == 2" />
            <span v-else>{{ scope.row.appName || '— —' }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="forensicResult"
          label="取证状态"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="scope.row.hasRecords">
              <span v-if="scope.row.dealStatus === 0">待受理</span>
              <span v-if="scope.row.dealStatus === 1">取证中</span>
              <span v-if="scope.row.dealStatus === 2">已完成</span>
              <span v-if="scope.row.dealStatus === 3">已撤销</span>
            </template>
            <template v-if="scope.row.renderType == 1 || scope.row.taskOrigin === 1 || !scope.row.taskOrigin">
              <span v-if="scope.row.forensicResult === '---' || scope.row.forensicResult === '失败'">— —</span>
              <span v-else :class="scope.row.forensicResult | statusFilter">{{ scope.row.forensicResult }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="275">
          <template slot-scope="scope">
            <div class="table-export">
              <div v-if="scope.row.taskOrigin === 1" class="table-operate-wrap">
                <el-button @click="handleDetail(scope.row)">
                  详情
                </el-button>
                <el-button v-if="scope.row.forensicResult === '成功' && scope.row.unicomFlag" type="primary" @click="handleLookReport(scope.row)">
                  查看报告
                </el-button>
                <el-button v-if="scope.row.forensicResult === '成功'" @click="handleExport(scope.row)">
                  导出文件
                </el-button>
                <el-button v-if="scope.row.forensicResult === '待受理'" type="primary" @click="handleCancel(scope.row)">
                  撤销
                </el-button>
              </div>
              <div v-else-if="scope.row.taskOrigin === 2" class="table-operate-wrap">
                <template>
                  <el-button v-if="scope.row.renderType === 1" @click="handleDetail(scope.row)">
                    详情
                  </el-button>
                  <el-button v-if="scope.row.forensicResult === '成功' && scope.row.unicomFlag" type="primary" @click="handleLookReport(scope.row)">
                    查看报告
                  </el-button>
                </template>
                <template v-if="scope.row.renderType === 2 && scope.row.dealStatus === 2">
                  <el-button @click="handleFileExport(scope.row)">
                    导出文件
                  </el-button>
                </template>
              </div>
              <div v-else class="table-operate-wrap">
                <template>
                  <el-button @click="handleDetail(scope.row)">
                    详情
                  </el-button>
                  <el-button v-if="scope.row.forensicResult === '成功'" type="primary" @click="handleLookReport(scope.row)">
                    查看报告
                  </el-button>
                </template>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="items.total"
        class="pagination-wrap"
        background
        :current-page="items.pageNum"
        :page-size="items.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="items.total"
        @size-change="setPageSize"
        @current-change="setPageNum"
      />
      <!-- /分页 -->
    </div>
    <!-- E 表格 -->

    <!-- S 文件导入提示 -->
    <el-dialog
      title="导入文件"
      :visible.sync="importTips"
      custom-class="importTips"
      top="0"
      width="20%"
    >
      <div class="imgTips">
        <img src="../../assets/imgs/u211.png" alt="">
      </div>
      <span class="tips">是否导入文件并提交深度取证?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importTips = false">放 弃</el-button>
        <el-upload
          ref="Import"
          action
          accept=".zip,"
          :on-change="handleBeforeImport"
          :http-request="handleImport"
          :multiple="false"
          :show-file-list="false"
        >
          <el-button type="primary">确 定</el-button>
        </el-upload>
      </span>
    </el-dialog>
    <!-- E 文件导入提示 -->

    <!-- S 详情 -->
    <ForensicDetail :id="showDetail.id" v-model="showDetail.visible" />
    <!-- E 详情 -->

    <!-- S 图片预览 -->
    <PreviewImg ref="preview" />
    <!-- E 图片预览 -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { TableSearch, PreviewImg } from '@/components'
import ForensicDetail from './components/ForensicDetail.vue'

export default {
  components: { TableSearch, ForensicDetail, PreviewImg },
  filters: {
    statusFilter(val) {
      if (val === '待取证' || val === '取证中' || val === '待受理') {
        return 'status-active'
      }
    }
  },
  data() {
    return {
      searchForm: {},
      searchOptions: [
        {
          field: 'username',
          label: '取证用户',
          placeholder: '',
          type: 'input'
        },
        {
          field: 'listDate',
          label: '',
          placeholder: '',
          type: 'daterange'
        }
      ],
      multipleSelection: [], // 表格多选
      showHeaderPopover: false,
      appOptions: [], // 应用列表
      appIds: [], // 选择的应用ID
      showDetail: {
        id: '',
        visible: false
      },
      videoTypes: ['rmvb', 'flv', 'mpg', 'wmv', 'avi', 'mov', 'mp4', 'mkv', 'vob'],
      file: '',
      importTips: false
    };
  },
  computed: {
    ...mapState({
      items: state => state.deepForensic.items,
      productName: state => state.product.item.productName,
      submitLoading: state => state.deepForensic.submitLoading,
      screenTimeLabel: state => state.product.screenTimeLabel
    })
  },
  watch: {
    productName(val) {
      this.appIds = []
      this.clearFilter()
      this.getList()
    },
    appIds(val) {
      this.$store.commit('deepForensic/setFilter', { aId: val })
    }
  },
  beforeRouteLeave(to, form, next) {
    this.clearFilter()
    next()
  },
  mounted() {
    if (!this.isMainAccount) this.searchOptions.splice(0, 1)
    this.searchForm = this.items.search
    const { query } = this.$route
    if (query.forensicId) { // 是否上传一张已存在的图片
      this.$store.commit('deepForensic/setPageNum', 1)
    }
    this.getList({
      forensicId: query.forensicId
    });
  },
  methods: {
    ...mapActions({
      getList: 'deepForensic/getList',
      getAppList: 'product/getAppList',
      setSearch: 'deepForensic/setSearch',
      setPageNum: 'deepForensic/setPageNum',
      setPageSize: 'deepForensic/setPageSize',
      setSort: 'deepForensic/setSort',
      setFilter: 'deepForensic/setFilter',
      clearFilter: 'deepForensic/clearFilter',
      remove: 'deepForensic/remove',
      cancel: 'deepForensic/cancel',
      exportZip: 'forensic/exportZip',
      setForensicItem: 'forensic/setForensicItem',
      importFailedFile: 'deepForensic/importFailedFile',
      getRecordList: 'deepForensic/getRecordList',
      exportTask: 'deepForensic/exportTask'
    }),
    handleLoadRecord(tree, treeNode, resolve) {
      this.getRecordList({ id: tree.id }).then(res => {
        const data = res.map((item) => {
          item.isTaskRecord = 1
          return item
        })
        resolve(data)
      })
    },
    // 撤销
    handleCancel(row) {
      this.$alert('您确定要撤销深度取证申请吗？', '撤销', {
        showCancelButton: true,
        center: true
      }).then(action => {
        if (action === 'confirm') {
          this.cancel({ id: row.renderType === 1 ? row.forensicId : row.id }).then(res => {
            this.linkTo('/selfForensic/list')
            this.$message({
              type: 'success',
              message: '撤销成功',
              center: true
            })
          })
        }
      });
    },
    // 图片预览
    handlePreviewImg(row) {
      this.$refs.preview.visible = true
      this.$refs.preview.src = row.sourceImagePath
    },
    // 提交选择的应用
    handleSubmitApp() {
      this.showHeaderPopover = false;
      this.getList()
    },
    handleResetApp() {
      this.appIds = [];
      this.showHeaderPopover = false;
      this.clearFilter()
      this.getList()
    },
    handleGetApps() {
      this.getAppList().then(res => {
        this.appOptions = res;
      })
    },
    // 批量删除
    handleDeleteSubmit() {
      if (this.multipleSelection.length === 0) {
        this.$message.error({
          message: '请选择要删除的记录',
          duration: 3000,
          center: true
        });
      } else {
        this.$alert('删除之后不可恢复，确定删除？', '删除', {
          showCancelButton: true,
          center: true
        }).then(action => {
          if (action === 'confirm') {
            const ids = this.multipleSelection.map(item => {
              return item.id;
            });
            this.remove({
              ids: ids
            }).then(res => {
              this.$message({
                type: 'success',
                message: '删除成功',
                center: true
              });
              this.getList()
            });
          }
        });
      }
    },
    // 导入zip包前判断
    handleBeforeImport(file) {
      this.importTips = false
      const isLt500M = file.size / 1024 / 1024 < 500
      const type = file.type ? file.type.split('/')[1].toLowerCase().split('-')[1] : ''
      if (type !== 'zip') {
        this.$message.error({ message: '请选择zip格式的样本文件', center: true });
        throw new Error('导入文件格式不正确')
      } else if (!isLt500M) {
        this.$message.error({ message: '上传文件大小不能超过500M', center: true });
        throw new Error('文件大小不能大于500M')
      } else {
        this.file = file
      }
    },
    // 导入zip包
    handleImport() {
      const loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      });
      const params = {
        'file': this.file
      }
      this.importFailedFile(params).then(res => {
        loading.close()
        if (res.status == 0) {
          this.$message.success(`${res.message}`)
          this.getList()
        } else {
          this.$message.error(`${res.message}`)
        }
      })
    },
    handleSelectable(row) {
      if (
        (row.dealStatus === 0 || row.dealStatus === 1) ||
        (row.isTaskRecord && row.isTaskRecord == 1)
      ) {
        return 0;
      } else {
        return 1;
      }
    },
    // 查看详情
    handleDetail(row) {
      this.showDetail.visible = true
      this.showDetail.id = row.renderType === 1 ? row.forensicId : row.id
    },
    // 查看报告
    handleLookReport(row) {
      const id = row.renderType === 1 ? row.forensicId : row.id
      this.setForensicItem(row).then(() => {
        this.linkTo(`/forensic/component?id=${id}`)
      })
    },
    // 单条文件导出
    handleExport(row) {
      const id = row.renderType === 1 ? row.forensicId : row.id
      window.location.href = '/api/v1/forensic/front/forensic/' + id + '/export';
    },
    // 任务文件导出
    handleFileExport(row) {
      const params = {
        taskId: row.id
      }
      this.exportTask(params).then(res => {
        const aLink = document.createElement('a')
        aLink.style.display = 'none'
        aLink.href = res
        document.body.appendChild(aLink)
        aLink.click()
        document.body.removeChild(aLink)
      })
    }
  }
};
</script>
<style lang="scss">
#deepForensicList{
  height: 100%;
  background: #fff;
  .btn-group {
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    .el-button {
      width: 100px;
      height: 40px;
      padding: 0;
    }
    .btn-item {
      display: flex;
      margin-right: 10px;
      &:last-child {
        margin-left: 0;
      }
      .el-button:first-child {
        margin-right: 15px;
      }
    }
  }
  .status-active {
    color: #fb9a32;
  }
  .table-export {
    display: flex;
  }
  .table-operate-wrap {
    .el-button {
      margin-left: 10px;
    }
  }
  .importTips {
    .imgTips {
      width: 120px;
      height: 120px;
      margin: 50px auto;
      margin-bottom: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tips {
      display: block;
      width: 190px;
      margin: auto;
    }
    .el-dialog__body {
      height: 300px;
      padding-bottom: 0;
      border-bottom: 1px solid #ededed;
    }
    .el-dialog__footer {
      display: flex;
      justify-content: flex-end;
      .el-button {
        width: 100px;
        height: 40px;
      }
      .dialog-footer {
        width: 214px;
        display: flex;
        div {
          margin-left: 10px;
        }
      }
    }
  }

}
</style>
